module.exports = __webpack_public_path__ + "img/Neo-Tips-Pic1.95e062f7.png";